module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul class="imageList">\n\n</ul>\n';
 if(mode == 'display'){ 
__p+='\n<a href="#" class="button button-secondary button-add-image">\n    Choose Icon\n</a>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./offers/templates/image-list.html
// module id = 297
// module chunks = 0